<div class="lum-page lum-page__card lum-c-bom-details">
  <header class="lum-page-header lum-page-header--sticky">
    <h2 class="lum-page-header__heading">
      <a [routerLink]="['/bom']">Bills of Materials</a> /
      {{ bom?.name }}
    </h2>
    <div class="lum-page-header__actions">
      <a class="lum-button lum-button--primary" [routerLink]="['/bom/edit', bomId]">
        <lum-ui-icon icon="edit"></lum-ui-icon>
        Edit
      </a>
    </div>
  </header>

  <div class="lum-page-content">
    <div class="d-flex justify-content-between align-items-baseline">
      <div>
        <h4 class="m-0">{{ bom?.name }}</h4>
      </div>
    </div>
    <table
      *ngIf="bom?.items.length > 0"
      class="lum-table lum-table--classic striped"
    >
      <thead>
        <tr>
          <th class="w-p35">SKU</th>
          <th class="w-p15">Quantity</th>
          <th class="w-p15">Unit</th>
          <th class="w-p15">Unit Price</th>
          <th class="w-p20">Total Price</th>
          <th class="w-p35">Notes</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of bom?.items; trackBy: trackById">
          <tr>
            <td>
              <ng-container *ngIf="item?.rfq?.productName; else noRfq">
                {{ item?.rfq?.productName }} [{{ item?.rfq?.internalSku }}]
              </ng-container>
              <ng-template #noRfq> No SKU found. </ng-template>
            </td>
            <td>{{ item?.quantity }}</td>
            <td>{{ item?.unitOfMeasure?.name }}</td>
            <td>{{ item?.calculatedPrice?.unitPrice }}</td>
            <td>{{ item?.calculatedPrice?.totalPrice | decimalPlaces }}</td>
            <td>{{ item?.note }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <ng-template #noData>
    <div class="mb-5"></div>
    <strong>N/A</strong>
  </ng-template>
</div>
